import { configureStore } from "@reduxjs/toolkit";
import { FLUSH, PAUSE, PERSIST, PURGE, REGISTER, REHYDRATE } from "redux-persist";
import persistReducer from "redux-persist/es/persistReducer";
import persistStore from "redux-persist/es/persistStore";
import storage from "redux-persist/lib/storage";
import reducers from "../reducers";



const persistConfig = {
    key: 'root',
    storage : storage,
}

const _persistedReducer = persistReducer(persistConfig, reducers)

export const store = configureStore({
    reducer : _persistedReducer,
    middleware : (getDefaultMiddleware) => getDefaultMiddleware({
        serializableCheck:{
            ignoreActions:[
                FLUSH,
                REHYDRATE,
                PAUSE,
                PERSIST,
                PURGE,
                REGISTER

            ],
        },
    }),
})

export const persistor = persistStore(store)